import { SummaryFeatureList } from '../types';

// The list of the order in which summary display features should be shown.
// Also maps where feature set items should be combined or split for display purposes
// To make TS happy we still have to map standalone features to an empty array
const PremierAnnualFeatureList: SummaryFeatureList = [
  'click_map_qt',
  'sentiment',
  'response_quality_enabled',
  'crosstabs',
  'analyze_combine_filters',
  'extended_piping',
  'collector_white_label_enabled',
];

export default PremierAnnualFeatureList;
